import { styled } from '@mui/material';

import { generateClasses } from '../../../../../../../../../utils/helper';
import AcadlyRadioOption, {
  radioOptionClasses,
} from '../../../../../../../../../components/FormControls/RadioGroup/RadioOption';
import ClassWidget from '../../../../../../../ClassWidget';

export const classListClasses = generateClasses('ClassList', ['classCard', 'selectedClass']);

export const RadioOption = styled(AcadlyRadioOption)(() => ({
  margin: 0,
  [`& .${radioOptionClasses.radioRoot}`]: {
    display: 'none',
  },
  [`& .${classListClasses.classCard}`]: {
    // flex property should work here because RadioOption is a flex container
    flex: 1,
  },
}));

export const ClassCard = styled(ClassWidget)(({ theme }) => ({
  [`&.${classListClasses.selectedClass}`]: {
    borderColor: 'transparent',
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: -2,
  },
}));
